'use strict';
define(['app'], function (app) {
    app.component('stCarousel', {
        templateUrl: 'app/components/st-carousel/st-carousel.html',
        controller: controller,
        transclude: true,
        bindings: {
            testimonials: '<'
        }
    });
    controller.$inject = ['$scope'];

    function controller($scope) {
        var ctrl = this;
        ctrl.testimonials = [];
        $scope.activeSlide = 0;
        $scope.plusSlides = plusSlides;
        $scope.currentSlide = currentSlide;

        $scope.$watch('$ctrl.testimonials', function (testimonials) {
            if (testimonials && testimonials.length) {
                ctrl.testimonials = testimonials;
                $scope.activeSlide = Math.min($scope.activeSlide, testimonials.length - 1);
            }
        });

        function plusSlides(n) {
            showSlides($scope.activeSlide + n);
        }

        function currentSlide(n) {
            showSlides(n - 1);
        }

        function showSlides(n) {
            var total = ctrl.testimonials.length;
            if (!total) {
                return;
            }
            $scope.activeSlide = ((n % total) + total) % total;
        }
    }
});
